import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Subscription } from 'rxjs';

import { Message } from 'primeng/api';
import { MessageService } from "@shared/services/message-service"
import { AuthService } from '@shared/authentication/auth.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
    @Input() position: string = 'top-right';
    @Input() hideOnClick: boolean = false;
    authMessage: { summary: string, detail: string} = null;

    subscriptions: Subscription[];

    constructor(
        private authService: AuthService,
        private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.subscriptions = [
            this.authService.AuthMessage.subscribe(msg => {
                setTimeout(() => { this.authMessage = msg; });
            })
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => { s.unsubscribe(); });
    }

    onCloseMessage(event: { message: Message }): void {
        this.messageService.removeMessage(event.message);
    }
}
